import billingNewCreditCardTemplate from './billingNewCreditCard.html';

export default function tnBillingDirectiveNewCreditCard() {
    return {
        template: billingNewCreditCardTemplate,
        scope: {
            cc: '=',
            ccerror: '=',
            saveCard: '=?',
        },
        link: function (scope) {
            scope.currentYear = new Date().getFullYear() - 2000;
            scope.saveCard = true;
        },
    };
}
